import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { DismissFilled } from '@fluentui/react-icons';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AssetForm } from '@ui/components/Forms';
const AssetDialog = ({ isOpen, onClose, variant = 'add' }) => {
    const { t } = useTranslation();
    const [trigger, setTrigger] = useState(false);
    const handleConfirm = () => {
        setTrigger(true);
    };
    const handleClose = () => {
        onClose();
        setTrigger(false);
    };
    return (_jsxs(Dialog, { open: isOpen, onClose: handleClose, maxWidth: 'sm', PaperProps: {
            sx: {
                width: '564px'
            }
        }, fullWidth: true, "aria-labelledby": 'AssetDialog', onKeyDown: (e) => e.key === 'Enter' && handleConfirm(), children: [_jsxs(DialogTitle, { id: 'add-vehicle-dialog', sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsxs(Typography, { variant: 'h6', color: 'text.primary', children: [variant === 'add' ? 'Add' : 'Edit', " Asset"] }), _jsx(IconButton, { onClick: handleClose, children: _jsx(DismissFilled, { fontSize: 18 }) })] }), _jsx(Divider, {}), _jsx(DialogContent, { children: _jsx(Box, { className: 'form-wrapper', sx: { mt: 1 }, children: _jsx(AssetForm, { trigger: trigger, setTrigger: setTrigger, onClose: onClose }) }) }), _jsx(Divider, {}), _jsxs(DialogActions, { sx: { p: 3 }, children: [_jsx(Button, { onClick: handleConfirm, variant: 'contained', color: 'inherit', loading: false, type: 'submit', children: t('Confirm') }), _jsx(Button, { onClick: handleClose, color: 'inherit', variant: 'outlined', children: t('Cancel') })] })] }));
};
export default AssetDialog;
